import script from "./AddDocument.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddDocument.vue?vue&type=script&setup=true&lang=ts"

import "./AddDocument.vue?vue&type=style&index=0&id=0cf87e8a&lang=css"

const __exports__ = script;

export default __exports__